export function useInventoryAPI() {
  const { errors, request } = useRequest();

  async function getLocationByFitterId() {
    const url = versionedUrl('Inventory/GetLocationByFitterId');

    return await request<LocationDTO[]>(url);
  }

  async function GetLocationItems(requestBody: LocationItemForLocationIdsRequest, includeImages: boolean) {
    const url = `${versionedUrl('Inventory/GetLocationItems')}?includeImages=${includeImages}`;

    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<LocationItems>(url, requestOptions);
  }

  async function moveItemsBetweenLocations(locationItem: MoveLocationItemRequest) {
    const url = versionedUrl('Inventory/MoveItemsBetweenLocations');

    const requestOptions: RequestOptions = {
      method: 'post',
      body: locationItem
    };

    return await request<LocationItem[]>(url, requestOptions);
  }

  async function getLocationItemForLocation(itemId: number, locationId: string) {
    const params = new URLSearchParams({
      itemId: itemId.toString(),
      locationId: locationId.toString()
    });
    const url = `${versionedUrl('Inventory/GetLocationItemForLocation')}?${params.toString()}`;

    return await request<LocationItem>(url);
  }

  return {
    errors,
    moveItemsBetweenLocations,
    getLocationByFitterId,
    GetLocationItems,
    getLocationItemForLocation
  };
}
